<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="type of service"
            rules="required"
          >
            <b-form-group
              label="type of service"
              label-for="type of service"
            >
              <b-form-select
                id="type_of_service"
                v-model="adminInitialForm.type_of_service"
                :options="optionsSource"
                trim
                placeholder="service"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="assigned employee"
            rules="required"
          >
            <b-form-group
              label="assigned employee"
              label-for="assigned employee"
            >
              <b-form-select
                v-model="adminInitialForm.assigned_employee"
                :options="optionsUsers"
                text-field="label"
                value="value"
                placeholder="Evaluator"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="status"
            rules="required"
          >
            <b-form-group
              label="status"
              label-for="status"
            >
              <b-form-select
                id="status"
                v-model="adminInitialForm.status"
                :options="optionsStatus"
                :state="getValidationState(validationContext)"
                trim
                placeholder="status"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="type of complaint"
            rules="required"
          >
            <b-form-group
              label="type of complaint"
              label-for="type of complaint"
            >
              <b-form-select
                id="type_of_complaint"
                v-model="adminInitialForm.type_of_complaint"
                :options="optionsTypeOfComplaint"
                :state="getValidationState(validationContext)"
                trim
                placeholder="complaint"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      optionsStatus: [
        { value: 'pending', text: 'pending' },
        { value: 'rejected', text: 'rejected' },
        { value: 'closed', text: 'closed' },
        { value: 'investigating by assigned employee', text: 'investigating by assigned employee' },
        { value: 'investigating by responsible employee', text: 'investigating by responsible employee' },
        { value: 'awaiting verification', text: 'awaiting verification' },
      ],
      optionsTypeOfComplaint:
        [{ value: 'General/Quality', text: 'General/Quality' },
          { value: 'Operations - General', text: 'Operations - General' },
          { value: 'Operations - Food Department', text: 'Operations - Food Department' },
          { value: 'Technical - General', text: 'Technical - General' },
          { value: 'Technical - Food Department', text: 'Technical - Food Department' },
          { value: 'HR Matters', text: 'HR Matters' },
          { value: 'Marketing', text: 'Marketing' },
        ],
      optionsSource: [
        { value: 'MOIAT', text: 'MOIAT' },
        { value: 'SASO', text: 'SASO' },
        { value: 'SFDA', text: 'SFDA' },
        { value: 'Others', text: 'Others' },
      ],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const adminInitialForm = ref({
    })
    return {
      getValidationState,
      adminInitialForm,
    }
  },
  computed: {
    optionsUsers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {

    addAdminInitial() {
      this.loader = true
      const formData = new FormData()

      // Use Object.entries() to iterate over the object's own properties
      Object.entries(this.adminInitialForm).forEach(([key, value]) => {
        formData.append(key, value)
      })

      axios
        .post(`complaints/${this.$route.params.id}/process/admin`, formData)
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'index-complaint' })
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        })
        .catch(error => {
          if (error.response.status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.message}`,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

  },
}
</script>
